export default Object.freeze({
  ONE: 'https://res.cloudinary.com/riteshp2000/image/upload/w_auto,f_auto,q_auto/v1637704359/project-guava/Signit_wgyayh.png',
  DSC: 'https://res.cloudinary.com/riteshp2000/image/upload/w_auto,f_auto,q_auto/v1637704232/project-guava/Group_3_1_an5um6.png',
});
